import questions from "./quiz.json";

export const selectQuestionNumber = (state) => state.question;
export const selectCorrect = (state) => state.correct;
export const selectCurrentQuestion = (state) => questions[state.questionId];
